import React from 'react';
import { LoginTemplate } from '../components';

export const Login = () => {
  return (
    <LoginTemplate />
  )
}
